import getProducts from "@/services/getProductsService";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";

const useProductsQuery = (searchTerm: string | null, reload?: number|null) => {
  const {
    data,
    isSuccess,
    isError,
    isPending: loading,
    refetch,
  } = useQuery({
    queryKey: ["syf-partner-products", searchTerm,reload],
    queryFn: async () => {
      const data = await getProducts(searchTerm || "");
      return data;
    },
    staleTime: Infinity,
    gcTime: 1000 * 60 * 60 * 24, // 24 hours
  });

  useEffect(() => {
    refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm,reload]);

  return {
    response: data,
    isSuccess,
    isError,
    loading,
    refetch,
  };
};

export default useProductsQuery;
